import "../styles/pages/Page2.css";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "../utils/axiosConfig";
import CreateGroupModal from "../components/dashboard/CreateGroupModal";
import JoinGroupModal from "../components/dashboard/JoinGroupModal";
import GroupCard from "../components/dashboard/GroupCard";
import Navbar from "../components/common/Navbar";
import { ShieldCheck } from "lucide-react";

const AdminDashboard = () => {
  const [showModal, setShowModal] = useState(false);
  const [groups, setGroups] = useState([]); // ✅ Always an array
  const [showJoinModal, setShowJoinModal] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    try {
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      if (user.role === "admin" || user.email === "fotographiyaworld@gmail.com") {
        setIsAdmin(true);
      }
    } catch (e) {}
  }, []);

  useEffect(() => {
    const fetchGroups = async () => {
      setIsLoading(true);
      try {
        const res = await api.get("/groups/all");
        console.log("✅ Groups fetched:", res.data);

        // ✅ Make sure res.data.groups is an array
        setGroups(Array.isArray(res.data.groups) ? res.data.groups : []);
      } catch (err) {
        console.error("❌ Error fetching groups:", err);
        setGroups([]); // fallback empty
      } finally {
        setIsLoading(false);
      }
    };

    fetchGroups();
  }, []);

  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);
  const handleJoinClick = () => setShowJoinModal(true);

  const handleGroupCreated = (newGroupData) => {
    const newGroup = newGroupData.group || newGroupData; // Support both formats
    setGroups((prev) => [...prev, newGroup]);
  };

  return (
    <>
      <Navbar />
      <main className="page2">
        <div className="back">
          <div className="text">
            <h1>Albums</h1>
            <div className="right-text">
              {isAdmin && (
                <button
                  className="btn-super-admin-nav"
                  onClick={() => navigate("/super-admin")}
                  title="Open Super Admin Platform Management Console"
                >
                  <ShieldCheck size={18} />
                  <span>Super Admin Console</span>
                </button>
              )}

              <button
                className="btn btn-secondary button1"
                onClick={handleJoinClick}
              >
                Join Album
              </button>
              <button
                className="btn btn-primary button2"
                onClick={handleOpenModal}
              >
                Create Album
              </button>
            </div>
          </div>

          <div className="group-list">
            {isLoading ? (
              Array.from({ length: 4 }).map((_, index) => (
                <div key={index} className="skeleton-card">
                  <div className="skeleton skeleton-thumbnail"></div>
                  <div className="group-info">
                    <div className="skeleton skeleton-title"></div>
                    <div className="skeleton skeleton-count"></div>
                  </div>
                </div>
              ))
            ) : Array.isArray(groups) && groups.length > 0 ? (
              groups.map((group, index) => (
                <div
                  key={group._id}
                  className="animate-card-fade-up"
                  style={{ animationDelay: `${Math.min(index * 0.05, 0.5)}s` }}
                >
                  <GroupCard
                    group={group}
                    onClick={() => navigate(`/group/${group._id}`)}
                  />
                </div>
              ))
            ) : (
              <p
                style={{
                  color: "#555",
                  textAlign: "center",
                  marginTop: "2rem",
                  width: "100%",
                }}
              >
                No groups found or there is a problem loading.
              </p>
            )}
          </div>
        </div>
      </main>

      <CreateGroupModal
        showModal={showModal}
        onClose={handleCloseModal}
        onGroupCreated={handleGroupCreated}
      />

      <JoinGroupModal
        showModal={showJoinModal}
        onClose={() => setShowJoinModal(false)}
      />
    </>
  );
};

export default AdminDashboard;
